import { useGetProfit } from "./useGetProfit";
import { useAtom } from "jotai";
import { GoalAtom } from "./atoms";
import { useCallback } from "react";
import nr from "newton-raphson-method";

export function useGetGoalReachedYearDelta() {
  const profit = useGetProfit();
  const [goal] = useAtom(GoalAtom);
  return useCallback(() => {
    if (profit(0) >= goal) {
      return 0;
    }
    let nr1 = nr(x => profit(x) - goal, 0);
    return nr1 === false ? Number.POSITIVE_INFINITY : nr1;
  }, [goal, profit]);
}
